import React from 'react';
import styled from 'styled-components';
import { useLocation, useParams } from 'react-router';
import { Box, Grid } from '@wegroup/design-system';

// Components
import QuestionViewText from './QuestionViewText';

// Redux
import QuestionViewHeaderSupportButton from './QuestionViewHeaderSupportButton';
import { useFlowsSelector } from '../../../../../common/src/utils/globalVariables';
import ProgressBar from '../../../../../flows/src/components/ui/advisory-flow/components/toolbar/ProgressBar';
import Avatar from '../../default/ProdFacAvatar';
import { mq } from '../../../../../common/src/utils/styledComponentsUtils';

interface Props {
  showBack?: boolean;
  withLogo?: boolean;
  backHandler?: () => void;
}

const ViewHeader: React.FC<React.PropsWithChildren<Props>> = ({
  showBack = true,
  backHandler,
  ...rest
}) => {
  const location = useLocation();
  const { position } = useParams<{
    position: string;
  }>();

  const questionnaire = useFlowsSelector((state) => state.flows.questionnaire);

  const currentTag = questionnaire.groups[position]?.tag;
  const nextTag = questionnaire.groups.find(({ tag: _tag }, index) => {
    const previousTag = questionnaire.groups[index - 1]?.tag;
    return previousTag === currentTag && _tag !== currentTag;
  })?.tag;

  const isSelection = location.pathname.includes('selection');
  const isFinalizeQuestionsView = location.pathname.includes('/finalize');

  return !location.pathname.match(new RegExp('/product/session/(offers).*')) ? (
    <Box
      position="relative"
      p="4"
      maxW="100vw"
      background="primary.50"
      borderBottom="1px"
      borderColor="gray.50"
      data-test-id="ProdFac_QuestionViewHeader"
      {...rest}
    >
      <Grid
        alignItems="center"
        gridGap="2"
        templateColumns={{
          base: '1fr repeat(2, 4.4rem)',
          mobileM: '4.4rem 1fr repeat(2, 4.4rem)',
        }}
        mb={isSelection || isFinalizeQuestionsView ? '0' : '4'}
      >
        <StyledAvatar />
        <QuestionViewText
          isSelection={isSelection}
          currentTag={currentTag}
          nextTag={nextTag}
          position={parseInt(position)}
        />
        <QuestionViewHeaderSupportButton />
      </Grid>
      {!isSelection && !isFinalizeQuestionsView && <ProgressBar />}
    </Box>
  ) : null;
};

const StyledAvatar = styled(Avatar)`
  height: 4.4rem;
  width: 4.4rem;
  display: none;

  ${mq.mobileM} {
    display: block;
  }
`;

export default ViewHeader;
